export default function BookingInfo() {
  const openBooking = () => {
    window.open('https://book.squareup.com/appointments/yc3ukarfxsbty9/location/LHRN4K68W4NE0', '_blank');
  };

  return (
    <section id="booking" className="py-20 bg-gradient-to-r from-slate-900 to-slate-800">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Left Side - How To Book */}
          <div className="text-white">
            <h2 className="text-5xl md:text-6xl font-bold mb-12">How To Book</h2>
            <div className="space-y-6">
              {[
                'Book online anytime — 24/7',
                'Choose your preferred barber and service when booking',
                "We'll securely store your card details — no upfront payment required. You can pay in-store (cash or card)",
                'Takes less than 30 seconds to book',
              ].map((text, i) => (
                <div key={i} className="flex items-start gap-4">
                  <div className="w-8 h-8 bg-red-600 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-check-line text-white text-lg"></i>
                  </div>
                  <p className="text-lg text-gray-300 leading-relaxed">{text}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Right Side - Important Booking Rules */}
          <div className="bg-red-900 rounded-3xl p-10 relative overflow-hidden">
            <div className="relative z-10">
              <h3 className="text-4xl font-bold text-white mb-8">Important Booking Rules</h3>
              <div className="space-y-6 mb-10">
                {[
                  'Please allow at least 2 hours notice for bookings or cancellations',
                  "If you arrive late and there isn't enough time before the next appointment, your booking may need to be cancelled",
                  'No-shows, last-minute cancellations, or cancelled appointments due to late arrival may incur a 50% service fee',
                ].map((rule, i) => (
                  <div key={i} className="flex items-start gap-4">
                    <span className="text-white text-2xl font-bold flex-shrink-0">{i + 1}.</span>
                    <p className="text-white text-lg leading-relaxed">{rule}</p>
                  </div>
                ))}
              </div>
              <button
                onClick={openBooking}
                className="w-full bg-white text-red-900 py-4 rounded-lg text-lg font-bold hover:bg-gray-100 transition-all flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-calendar-line text-xl"></i>
                BOOK YOUR APPOINTMENT
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
